/**
 * Names the sampling-rate instrumentation writes, shared with the e2e spec that reads them back.
 * Kept free of imports so the Playwright process can load it without the Faro browser SDK.
 */

/** The Faro session attribute carrying the rate (`session_attr_sampling_rate` in Loki). */
export const SAMPLING_RATE_ATTRIBUTE = 'sampling_rate';

/** Where the rate a session was sampled at is kept, next to the session Faro stores. */
export const SESSION_SAMPLING_RATE_KEY = 'psp.faroSessionSamplingRate';
